import { combineReducers } from 'redux';

import accountCreationError     from './account_creation_error';
import activeEnrollStep         from './active_enroll_step';
import activeModal              from './active_modal';
import activeProduct            from './active_product';
import activeFeaturedSelection  from './active_featured_selection';
import activeFilter             from './active_filter';
import activeFilterResult       from './active_filter_result';
import activeUpgradeStep        from './active_upgrade_step';
import braintreeFailure         from './braintree_failure';
import campaign                 from './campaign';
import cartError                from './cart_error';
import categories               from './categories';
import computedCart             from './computed_cart';
import creditAcceptState        from './credit_accept_state';
import creditView               from './credit_view';
import store                    from './store';
import customer                 from './customer';
import enrollShippingSuccess    from './enroll_shipping_success';
import enrollPaymentSuccess     from './enroll_payment_success';
import environment              from './environment';
import featured                 from './featured';
import feedback                 from './feedback';
import genres                   from './genres';
import headerDetailsOpen        from './header_details_open';
import declineBoxBook           from './decline_box_book';
import isLoggedIn               from './is_logged_in';
import isSoftLoggedIn           from './is_soft_logged_in';
import lastOrderCart            from './last_order_cart';
import loginError               from './login_error';
import maps                     from './maps';
import onetimePaymentSuccess    from './onetime_payment_success';
import products                 from './products';
import promos                   from './promos';
import promoMessage             from './promo_message';
import preorderMessage          from './preorder_message';
import ebookOrderSuccess        from './ebook_order_success';
import path                     from './path';
import urlParams                from './url_params';
import paymentMethods           from './payment_methods';
import searchSuggestions        from './search_suggestions';
import searchResults            from './search_results';
import searchQuery              from './search_query';
import searchLoading            from './search_loading';
import upgradeStatus            from './upgrade_status';
import sort                     from './sort';
import zendesk                  from './zendesk';

const rootReducer = combineReducers({
    activeEnrollStep,
    activeModal,
    activeProduct,
    activeFeaturedSelection,
    activeFilter,
    activeFilterResult,
    activeUpgradeStep,
    campaign,
    cartError,
    computedCart,
    categories,
    store,
    creditAcceptState,
    customer,
    ebookOrderSuccess,
    enrollPaymentSuccess,
    enrollShippingSuccess,
    environment,
    genres,
    feedback,
    featured,
    headerDetailsOpen,
    declineBoxBook,
    isLoggedIn,
    lastOrderCart,
    loginError,
    maps,
    path,
    products,
    promos,
    promoMessage,
    paymentMethods,
    onetimePaymentSuccess,
    preorderMessage,
    urlParams,
    accountCreationError,
    creditView,
    braintreeFailure,
    searchSuggestions,
    searchResults,
    searchQuery,
    searchLoading,
    isSoftLoggedIn,
    upgradeStatus,
    sort,
    zendesk
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/modules/index.js